<template>
  <div class="info-key-positioner">
    <arrow-animation
      v-if="showSideArrows && !tutorialState.showImpulseBar"
      position="bottom"
      style="position: absolute; left: 2%; width: 320px; height: 156px; bottom: 12%; transform-origin: 0 100%;"
    />
    <tutorial-keyboard-keys
      v-if="showSideArrows && !tutorialState.showImpulseBar"
      type="arrow-keys"
      :text="$t('webInfoAcceleration')"
      is-scaled
      class="keyboard-side-keys"
    >
      <section
        class="tutorial-keyboard-keys-wrapper"
      >
        <tutorial-keyboard-key
          type="arrow"
          rotation="left"
          letter="a"
          glow
        />
        <tutorial-keyboard-key
          type="arrow"
          rotation="right"
          letter="d"
          glow
        />
      </section>
    </tutorial-keyboard-keys>
  </div>
</template>

<script lang="ts">
import {
  ArrowAnimation,
  TutorialKeyboardKeys,
  TutorialKeyboardKey
} from '@powerplay/core-minigames-ui'

import { defineComponent } from 'vue'
import { tutorialState } from '@/stores'

export default defineComponent({
  name: 'TutorialInfoKeys',
  components: {
    ArrowAnimation,
    TutorialKeyboardKeys,
    TutorialKeyboardKey
  },
  data() {

    return {
      tutorialState: tutorialState(),
    }

  },
  computed: {
    showSideArrows() {

      return tutorialState().buttons.showMovementButtons || tutorialState().buttons.showButtonStart

    },
    showVerticalArrows() {

      return tutorialState().buttons.showMovementButtons

    }
  }
})
</script>

<style lang="less" scoped>
    .positioner {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 25%;

        .keyboard-side-keys {
            transform-origin: 0 100%;
            position: absolute;
            left: 2%;
            bottom: 10%;

            .tutorial-keyboard-keys-wrapper {
                height: 100px;
            }
        }
        .keyboard-vertical-keys {
            transform-origin: 100% 100%;
            position: absolute;
            right: 2%;
            bottom: 10%;

            .tutorial-keyboard-keys-wrapper {
                width: 100px;
            }
            .tutorial-keyboard-header {
                width: 140px;
            }
        }

        .keyboard-space {
            transform-origin: 100% 100%;
            position: absolute;
            right: 2%;
            bottom: 10%;
        }
    }
</style>
